function smoothScroll() {
    $('.js-scroll-link').click(function(ev) {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'')
          || location.hostname == this.hostname)
      {
          let target = $(this.hash);
          console.log(target, ' target');
        const headerHeight = $('.js-sticky-header').height() + 5; // Get fixed header height

        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      console.log(target,' target 2');
        if (target.length)
        {
          $('html,body').animate({
            scrollTop: target.offset().top - headerHeight
          }, 500);
          return false;
        }
      }
  });
}
